export default __webpack_public_path__ + "static/media/Di Battista.27d08497.jpg";